export default __webpack_public_path__ + "static/media/upsell-repeat-customers.437ce668.svg";